import { render, staticRenderFns } from "./CheckboxTemplate.vue?vue&type=template&id=23b8459c&scoped=true&"
import script from "./CheckboxTemplate.vue?vue&type=script&lang=js&"
export * from "./CheckboxTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxTemplate.vue?vue&type=style&index=0&id=23b8459c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b8459c",
  null
  
)

export default component.exports